import request from '@/utils/request'

let DxApi = {
  /*编辑*/
  getSetting(data) {
    return request._get('/shop/plus.dx.setting/index', data);
  },

  /*编辑*/
  saveSetting(data) {
    return request._post('/shop/plus.dx.setting/index', data);
  },
}

export default DxApi;



// WEBPACK FOOTER //
// ./src/api/dx.js